import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { primaryNavigation, secondaryNavigation } from "../../app/navigation.js";
import { NotificationsCount } from "../../features/notifications/NotificationsCount.jsx";
import { AxonIcon } from "../../icons/AxonIcon.jsx";

export function PrimaryNav() {
  const location = useLocation();
  const secondaryActive = secondaryNavigation.some((item) => (
    item.path === location.pathname
    || (item.path !== "/settings" && location.pathname.startsWith(`${item.path}/`))
  ));
  const [isOpen, setIsOpen] = useState(secondaryActive);

  useEffect(() => {
    if (secondaryActive) setIsOpen(true);
  }, [secondaryActive]);

  return (
    <nav className="primary-nav" aria-label="Основная навигация">
      <ol>
        {primaryNavigation.map((item) => (
          <li key={item.path}>
            <NavLink
              className={({ isActive }) => `primary-nav__link${isActive ? " is-active" : ""}`}
              to={item.path}
              end={item.path === "/"}
            >
              {({ isActive }) => (
                <>
                  <span className="primary-nav__index" aria-hidden="true">
                    {item.icon ? <AxonIcon name={item.icon} size={20} active={isActive} /> : item.index}
                  </span>
                  <span>{item.label}</span>
                  <span className="primary-nav__marker" aria-hidden="true" />
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ol>
      <button
        type="button"
        className={`primary-nav__more${secondaryActive ? " is-active" : ""}`}
        aria-expanded={isOpen}
        aria-controls="desktop-more-menu"
        onClick={() => setIsOpen((value) => !value)}
      >
        <AxonIcon name="more" size={20} active={secondaryActive || isOpen} />
        <span>Ещё</span>
        {isOpen ? null : <NotificationsCount />}
        <span aria-hidden="true">{isOpen ? "−" : "+"}</span>
      </button>
      {isOpen ? (
        <ol id="desktop-more-menu" className="primary-nav__secondary">
          {secondaryNavigation.map((item) => (
            <li key={item.path}>
              <NavLink
                className={({ isActive }) => `primary-nav__secondary-link${isActive ? " is-active" : ""}`}
                to={item.path}
                end
              >
                <AxonIcon name={item.icon} size={18} />
                <span>{item.label}</span>
                {item.path === "/notifications" ? <NotificationsCount /> : null}
              </NavLink>
            </li>
          ))}
        </ol>
      ) : null}
    </nav>
  );
}
